<app-card [cardTitle]="UploadfromExcel" [padding]="20">
    <ng-template #headerOptionsTemplate>
      <a href="javascript:" class="text-muted" mat-dialog-close>
        <i class="ti ti-x f-20"></i>
      </a>
    </ng-template>
    <div class="personal-details">
      <div mat-dialog-content class="row">
        <table class="table" width="100%"  border="0">
          <tr>
            <td>{{ 'SelectExcelFile' | translate }}</td>
            <td align="left"><input #file type="file" multiple (change)="onFileChange($event)" /></td>
            <td></td>
            <td align="left"
              ><button mat-flat-button color="primary" (click)="uploadfile()" mat-dialog-close>
                {{ 'upload' | translate }}
              </button></td
            >
          </tr>
        </table>
        <table>
          <thead>
            @for (column of excelHeaders; track column) {
              <th>{{ column }}</th>
            }
          </thead>
          @for (row of excelData; track row) {
            <tr>
              @for (column of excelHeaders; track column) {
                <td>{{ row[column] }}</td>
              }
            </tr>
          }
        </table>
      </div>
    </div>
  </app-card>
  